<oth-card
    *ngIf="employee.profile"
    [bodyTemplate]="bodyTemplate"
    [footerTemplate]="footerTemplate"
    [headerTemplate]="headerTemplate"
    class="employee-card">
  <!-- Header -->
  <ng-template #headerTemplate>
    <div class="header">
      <app-image-content-loader
          *ngIf="!employeePhotoLoaded"
          [imageContentLoaderClass]="'employee-photo'"></app-image-content-loader>
      <img
          (load)="setEmployeePhotoLoaded()"
          [src]="employee.profile.photoUri"
          [style]="'display:' + (!employeePhotoLoaded ? 'none;' : 'block;')"
          alt="profile-img"
          class="profile-image"
          onerror="this.src='./assets/common/profile-img.png'"/>
    </div>
  </ng-template>

  <!-- Body -->
  <ng-template #bodyTemplate>
    <div class="body">
      <p class="name">{{ employee.profile.name }}</p>
      <p class="title">{{ employee.profile.title }}</p>
      <p class="bio">{{ employee.profile.bio }}</p>
    </div>
  </ng-template>

  <!-- Footer -->
  <ng-template #footerTemplate>
    <div class="footer">
      <app-ext-link
          *ngIf="employee.profile.social.linkedIn"
          [href]="employee.profile.social.linkedIn">
        <i [class]="'fab fa-' + environmentCommon.website.linkedin.cssClass + ' fa-fw'"
           aria-hidden="true"
           body>
        </i>
      </app-ext-link>
      <app-ext-link
          *ngIf="employee.profile.social.github"
          [href]="employee.profile.social.github">
        <i [class]="'fab fa-' + environmentCommon.website.github.cssClass + ' fa-fw'"
           aria-hidden="true"
           body>
        </i>
      </app-ext-link>
    </div>
  </ng-template>
</oth-card>
